"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var Transition = function (_a) {
    var children = _a.children, when = _a.when, name = _a.name;
    var _b = (0, react_1.useState)(null), element = _b[0], setElement = _b[1];
    var _c = (0, react_1.useState)(false), mounted = _c[0], setMounted = _c[1];
    var _d = (0, react_1.useState)('enter'), state = _d[0], setState = _d[1];
    var _e = (0, react_1.useState)(false), active = _e[0], setActive = _e[1];
    var callbackRef = (0, react_1.useCallback)(function (element) {
        setElement(element);
    }, []);
    var className = (0, react_1.useMemo)(function () {
        var animationClass = "".concat(name, "-").concat(state);
        var activeClass = active ? "".concat(name, "-active") : null;
        return children && (0, classnames_1.default)(children.props.className, animationClass, activeClass);
    }, [name, state, active, children]);
    var onTransitionEnd = (0, react_1.useCallback)(function () {
        state === 'exit' && setMounted(false);
    }, [state]);
    (0, react_1.useEffect)(function () {
        setState(when ? 'enter' : 'exit');
        when && setMounted(true);
    }, [when]);
    (0, react_1.useEffect)(function () {
        requestAnimationFrame(function () {
            setActive(!!element);
        });
    }, [element]);
    (0, react_1.useEffect)(function () {
        element === null || element === void 0 ? void 0 : element.addEventListener('transitionend', onTransitionEnd);
        return function () { return element === null || element === void 0 ? void 0 : element.removeEventListener('transitionend', onTransitionEnd); };
    }, [element, onTransitionEnd]);
    return (mounted && (0, react_1.cloneElement)(children, {
        ref: callbackRef,
        className: className,
    }));
};
exports.default = Transition;
